import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "src/redux/store";
import useResponsive from "src/hooks/useResponsive";

const allergenArray = [
  {
    id: 1,
    name: "celery",
  },
  {
    id: 2,
    name: "crustacens",
  },
  {
    id: 3,
    name: "eggs",
  },
  {
    id: 4,
    name: "fish",
  },
  {
    id: 5,
    name: "gluten",
  },
  {
    id: 6,
    name: "lupin",
  },
  {
    id: 7,
    name: "milk",
  },
  {
    id: 8,
    name: "molluscs",
  },
  {
    id: 9,
    name: "mustard",
  },
  {
    id: 10,
    name: "peanut",
  },
  {
    id: 11,
    name: "sesame",
  },
  {
    id: 12,
    name: "soya",
  },
  {
    id: 13,
    name: "sulphurdioxide",
  },
  {
    id: 14,
    name: "treenut",
  },
];

function getAllergenNameById(id) {
  return allergenArray.find((al) => al.id == id)?.name;
}

const AllergenIcon = ({ id, isEnabled, onClick, widthSize }) => {
  const { t } = useTranslation();
  const width = useResponsive("down", "sm");

  if (isEnabled === undefined) isEnabled = true;
  let name = getAllergenNameById(id);
  let title = "Contiene ";
  title += t(`alergenos.${name}`);

  return (
    <Tooltip title={title}>
      <img
        style={{
          display: "inline",
          filter: `grayscale(${isEnabled ? 0 : 1})`,
        }}
        src={`/static/icons/allergen/${name}.svg`}
        width={widthSize ? widthSize : width ? 40 : 30}
        height={widthSize ? widthSize : width ? 40 : 30}
        onClick={onClick}
      />
    </Tooltip>
  );
};

AllergenIcon.propTypes = {
  id: PropTypes.number.isRequired,
};

export default AllergenIcon;
